export const uiColors = {
  primary: "#6b7280",
  primaryHover: "#4b5563",
  danger: "#dc2626",
  dangerHover: "#b91c1c",
  border: "rgba(17,24,39,0.08)",
  borderStrong: "rgba(17,24,39,0.12)",
  fieldBgLight: "rgba(255,255,255,0.86)",
  fieldBgDark: "rgba(31,31,31,0.96)",
};

export const uiRadii = {
  shell: 5,
  panel: 4,
  field: 2.25,
  pill: 999,
};

export const shellCardSx = {
  borderRadius: uiRadii.shell,
  border: `1px solid ${uiColors.border}`,
  boxShadow: "0 18px 40px rgba(17,24,39,0.08)",
  backgroundImage: "none",
};

export const panelSx = {
  borderRadius: uiRadii.panel,
  border: `1px solid ${uiColors.border}`,
  boxShadow: "0 10px 28px rgba(17,24,39,0.06)",
  p: 2.5,
};

export const dialogSx = {
  "& .MuiDialog-paper": {
    borderRadius: uiRadii.shell,
    border: `1px solid ${uiColors.border}`,
    boxShadow: "0 18px 40px rgba(17,24,39,0.10)",
    backgroundImage: "none",
  },
};

export const fieldSx = (isDark = false) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: uiRadii.field,
    backgroundColor: isDark ? uiColors.fieldBgDark : uiColors.fieldBgLight,
    color: isDark ? "#f9fafb" : "#111827",
    transition: "box-shadow 0.2s ease, border-color 0.2s ease, background-color 0.2s ease",
    "& fieldset": {
      borderColor: isDark ? "rgba(255,255,255,0.14)" : "rgba(17,24,39,0.1)",
    },
    "&:hover fieldset": {
      borderColor: isDark ? "rgba(255,255,255,0.22)" : "rgba(17,24,39,0.16)",
    },
    "&.Mui-focused": {
      boxShadow: "none",
    },
    "&.Mui-focused fieldset": {
      borderColor: isDark ? "rgba(255,255,255,0.28)" : uiColors.primary,
    },
    "& input": {
      color: isDark ? "#f9fafb" : "#111827",
      WebkitTextFillColor: isDark ? "#f9fafb" : "#111827",
    },
  },
  "& .MuiInputLabel-root": {
    color: isDark ? "rgba(255,255,255,0.62)" : "rgba(17,24,39,0.58)",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: isDark ? "rgba(255,255,255,0.72)" : uiColors.primaryHover,
  },
});

export const primaryButtonSx = {
  borderRadius: uiRadii.pill,
  px: 2.8,
  minHeight: 40,
  bgcolor: uiColors.primary,
  color: "#fff",
  fontWeight: 500,
  textTransform: "none",
  boxShadow: "none",
  "&:hover": { bgcolor: uiColors.primaryHover, boxShadow: "none" },
  "&.Mui-disabled": { bgcolor: "#d1d5db", color: "rgba(255,255,255,0.95)", boxShadow: "none" },
};

export const secondaryButtonSx = {
  borderRadius: uiRadii.pill,
  px: 2.8,
  minHeight: 40,
  color: "text.primary",
  textTransform: "none",
  boxShadow: "none",
};

export const outlinedButtonSx = {
  borderRadius: uiRadii.pill,
  px: 2.8,
  minHeight: 40,
  textTransform: "none",
  borderColor: uiColors.borderStrong,
};

export const destructiveButtonSx = {
  borderRadius: uiRadii.pill,
  px: 2.8,
  minHeight: 40,
  whiteSpace: "nowrap",
  bgcolor: uiColors.danger,
  color: "#fff",
  fontWeight: 500,
  textTransform: "none",
  boxShadow: "none",
  "&:hover": { bgcolor: uiColors.dangerHover, boxShadow: "none" },
  "&.Mui-disabled": { bgcolor: "#f3b4b4", color: "rgba(255,255,255,0.95)", boxShadow: "none" },
};

export const sectionTitleSx = { fontWeight: 600, mb: 0.5 };
export const sectionLeadSx = { color: "text.secondary", mb: 2 };
